export default "__VITE_ASSET__81d27b30__"